<dv-grid [actions]="actions()">
  <ag-grid-angular
    dvGridInSidesheet
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (rowDataUpdated)="onRowDataChanged()">
  </ag-grid-angular>
</dv-grid>
